import React, { useState, useEffect } from 'react';

import ActionButton from './ActionButton';
import ConfirmButton from './ConfirmButton';

const ToggleButton = (props) => {
	const getActualValue = () => {
		let v = props?.active ?? true;
		if(v == 'true' || v) return true;
		return false;
	};

	const [ active, setActive ] = useState(getActualValue());

	useEffect(() => {
		setActive(getActualValue());
	}, [ props.active ]);

	const onclick = (e) => {
		setActive(!active);
		if(props.onClick != undefined) props.onClick(e);
	};

	const icon_on = props?.icon ?? (props?._class?.icon ?? null);
	const icon_off = props?.icon_off ?? (props?._class?.icon_off ?? icon_on);

	const type = props?.confirm ?? 'button';

	const Component = (type == 'confirm') ? ConfirmButton : ActionButton;

	return (
		<Component
			{...props}
			icon={(active) ? icon_on : icon_off}
			onClick={onclick}
		>{props.children}</Component>
	);
}

export default ToggleButton;